



import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function ChangeNameLLP () {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 47) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

       localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };




const faqList = [
  {
    question: "What is the procedure to change the name of an LLP?",
    answer: "The process involves applying to the Registrar of Companies for name availability, passing a special resolution, and filing necessary forms for approval."
  },
  {
    question: "How long does the LLP name change process take?",
    answer: "Typically, the process takes 15 to 30 days, depending on the Registrar's response and document correctness."
  },
  {
    question: "Can we use any name for the LLP?",
    answer: "The proposed name must comply with the LLP naming guidelines and should not be identical or similar to existing companies or LLPs."
  },
  {
    question: "Is shareholder approval required for the name change?",
    answer: "Yes, a special resolution must be passed by the partners to approve the change of name."
  },
  {
    question: "Will the LLP number or registration details change after the name change?",
    answer: "No, only the name changes; all other registration details and identification numbers remain the same."
  },
  {
    question: "Can Dm2Legal assist in checking the availability of the new LLP name?",
    answer: "Yes, our experts will verify name availability and suggest alternatives if the preferred name is not available."
  },
  {
    question: "What documents are required for changing the LLP name?",
    answer: "Documents include the LLP agreement, resolution for name change, application forms, and identity proofs of partners."
  },
  {
    question: "Is it mandatory to advertise the name change publicly?",
    answer: "No statutory requirement exists to advertise, but partners may choose to notify stakeholders as per their discretion."
  },
  {
    question: "Are there any penalties for not updating the LLP name?",
    answer: "Yes, failure to update official records can lead to penalties and non-compliance notices."
  },
  {
    question: "Can the LLP revert to its old name after changing it?",
    answer: "No, once the name change is approved and registered, reverting back is not allowed."
  }
];









  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Change in Name of LLP</h1>

                <p className="pdrl-text">Get Change in Name (LLP) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Changing the name of your LLP is a crucial process that helps reflect your business’s evolving identity and brand. DM2Legal ensures smooth and hassle-free LLP name change services with complete compliance, expert guidance, and timely filings with the Registrar of Companies.
                </p>

                <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">Changing the name of your Limited Liability Partnership (LLP) is an important decision that can significantly impact your business’s branding and market presence. Whether you want to reflect a change in your business strategy, expand into new markets, or simply modernize your brand image, updating your LLP’s name ensures that your legal identity aligns perfectly with your business goals.

The process of changing an LLP name involves several critical steps including verifying the availability of the new name, obtaining partner approval through a special resolution, and filing the required forms with the Registrar of Companies (RoC). It is essential to comply with the Companies Act, 2013, and the LLP Rules to avoid legal complications.

DM2Legal provides comprehensive assistance throughout the name change process. Our team of experts handles everything from name availability searches to drafting resolutions and filing applications, ensuring a smooth, timely, and hassle-free experience. With our end-to-end services, you can focus on growing your business while we manage the regulatory formalities.

Changing your LLP’s name not only helps you maintain legal compliance but also strengthens your brand identity in the competitive marketplace. Trust DM2Legal to deliver reliable, efficient, and transparent LLP name change services with dedicated support at every ste.</p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Change-In-Name-of-LLP.png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon1.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Brand Alignment</a></h4>
        <p className="font-f-7">Change your LLP name to better reflect your business identity, offerings, and target market.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon2.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Legal Recognition</a></h4>
        <p className="font-f-7">Ensure that your new business name is officially approved and recognized by legal authorities.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Rebranding Opportunities</a></h4>
        <p className="font-f-7">Open new market opportunities by rebranding with a modern and strategic business name.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Avoid Legal Conflicts</a></h4>
        <p className="font-f-7">Eliminate risks of disputes with businesses having similar names and protect your brand identity.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon5.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Business Scope Expansion</a></h4>
        <p className="font-f-7">Reflect new areas of operation or expanded services with a fitting new LLP name.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon6.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Professional Image</a></h4>
        <p className="font-f-7">Boost your company’s reputation with a more professional and appealing name.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon7.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Consistency Across Documents</a></h4>
        <p className="font-f-7">Ensure all legal and business documents consistently reflect the new name.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon8.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Operational Continuity</a></h4>
        <p className="font-f-7">Maintain seamless operations while legally changing the LLP name.</p>
      </div>
    </div>
  </div>
</div>






          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our team reviews your existing LLP documents and checks the proposed new name for availability and compliance.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Draft a special resolution approving the LLP name change and obtain partners’ consent.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Prepare and file necessary forms (like Form RUN-LLP and Form LLP-5) with the Registrar of Companies.

                    </span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>After approval from the ROC, update the LLP agreement and other statutory records with the new name.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Receive the official certificate confirming the change in LLP name, completing the process.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default ChangeNameLLP ;

